import { Container } from "./styles";
import zeeshanahmad from "../../assets/zeeshanahmad.png";
import vscodeIcon from "../../assets/vscodeIcon.svg";
import mongodb from "../../assets/mongodb.svg";
import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import mysqlicon from "../../assets/mysqlicon.svg";
import boostrapIcon from "../../assets/bootstrap-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <>
      <Container id="about">
        <div className="about-text">
          <ScrollAnimation animateIn="fadeInLeft">
            <h2>About me</h2>
          </ScrollAnimation>
          <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
            <p>
              Passionate about web development and deeply immersed in the world
              of technology, I bring a wealth of experience and expertise to the
              table. With a comprehensive skill set encompassing JavaScript,
              TypeScript, React, Node.js, MongoDB, MySQL, HTML, and CSS, I am
              well-equipped to tackle a wide range of challenges in the digital
              landscape.
            </p>
          </ScrollAnimation>
          <ScrollAnimation
            animateIn="fadeInLeft"
            delay={0.2 * 1000}
            style={{ marginTop: "2rem", marginBottom: "2rem" }}
          >
            <p>
              My journey in the tech industry began with a curiosity for coding
              and a thirst for knowledge. Over the years, I have honed my skills
              through hands-on experience and continuous learning, constantly
              pushing the boundaries of what is possible in web development.
            </p>
          </ScrollAnimation>
          <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
            <p>
              In addition to technical proficiency, I bring a collaborative
              mindset and a passion for innovation to every team I work with. I
              thrive in environments that encourage creativity, collaboration,
              and out-of-the-box thinking, where I can contribute my skills and
              ideas to drive positive change and innovation.
            </p>
          </ScrollAnimation>
        </div>
        <div className="about-image">
          <ScrollAnimation animateIn="fadeInRight" delay={0.2 * 1000}>
            <img src={zeeshanahmad} alt="Zeeshan Ahamd" />
          </ScrollAnimation>
        </div>
      </Container>
      <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
        <h1
          style={{
            textAlign: "center",
            marginTop: "10rem",
            color: "var(--green)",
          }}
          id="skills"
        >
          Here are my main skills:
        </h1>
      </ScrollAnimation>
      <Container style={{ marginTop: "20px" }}>
        <div className="hard-skills">
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={reactIcon} alt="React" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={typescriptIcon} alt="Typescript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.16 * 1000}>
              <img src={nodeIcon} alt="Node" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.17 * 1000}>
              <img src={htmlIcon} alt="Html" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.18 * 1000}>
              <img src={cssIcon} alt="Css" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={boostrapIcon} alt="bootstrap" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={mongodb} alt="mongodb" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.15 * 1000}>
              <img src={mysqlicon} alt="mySql" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={vscodeIcon} alt="vscodeIcon" />
            </ScrollAnimation>
          </div>
        </div>
      </Container>
    </>
  );
}
